export function formatDateWithTime(inputDate: Date | string, inputTime: string) {
    let date: Date = inputDate ? (typeof inputDate === 'string' ? new Date(inputDate) : inputDate) : new Date();
    let dateToString = '';
    dateToString = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString().split("T")[0];
    return `${dateToString} ${inputTime}`;

}